'use strict';

var React = require('react'),
    { isArray } = require('underscore'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    StampItem = require('../organisms/StampItem'),
    ZineItem = require('../organisms/ZineItem'),
    PinterestImage = require('../molecules/PinterestImage'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Activity = require('../molecules/Activity'),
    UserItem = require('../organisms/UserItem'),
    assign = require('react/lib/Object.assign'),
    Message = require('../molecules/Message'),
    PropTypes = React.PropTypes;

require('./Collection.less');

var Collection = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  className: 'Collection',

  propTypes: {
    type: PropTypes.oneOf(['stamps', 'zines', 'pinterestImages', 'activities', 'users', 'messages']),
    mode: PropTypes.oneOf(['grid', 'list']),
    columns: PropTypes.number,
    keys: PropTypes.arrayOf(PropTypes.string),
    items: PropTypes.arrayOf(
      PropTypes.object.isRequired
    ).isRequired,
    itemProps: PropTypes.object,
    getItemProps: PropTypes.func
  },

  getCSSModifiers() {
    return [
      this.props.mode,
      this.props.type,
      typeof this.props.columns === 'number' && (this.props.columns + 'columns')
    ];
  },

  getItemProps(item, index) {
    return assign({},
      this.props.itemProps,
      this.props.getItemProps ? this.props.getItemProps(item, index) : null
    );
  },

  render() {
    var { items } = this.props;

    return (
      <div className={this.getClassName()}>
        {items.length > 0 &&
          items.map(this.renderItem)
        }

        {items.length === 0 && this.props.children}
      </div>
    );
  },

  getItemKey(item, index) {
    if (this.props.keys) {
      return this.props.keys[index];
    }

    switch (this.props.type) {
    case 'stamps':
      return item.id || item.uuid;

    case 'users':
    case 'activities':
    case 'messages':
      return item.id;

    case 'zines':
      return item.slug;

    case 'pinterestImages':
      return item.url;
    }
  },

  renderItem(item, index) {
    var itemComponent,
        key = this.getItemKey(item, index);

    switch (this.props.type) {
    case 'stamps':
      itemComponent = this.renderStamp(item, index);
      break;

    case 'zines':
      itemComponent = this.renderZine(item, index);
      break;

    case 'pinterestImages':
      itemComponent = this.renderPinterestImage(item, index);
      break;

    case 'activities':
      itemComponent = this.renderActivities(item, index);
      break;

    case 'users':
      itemComponent = this.renderUser(item, index);
      break;

    case 'messages':
      itemComponent = this.renderMessage(item, index);
      break;

    default:
      throw new Error('Unsupported type: ' + this.props.type);
    }

    return (
      <div className='Collection-item' key={key}>
        {itemComponent}
      </div>
    );
  },

  renderStamp(stamp, index) {
    return (
      <StampItem {...this.getItemProps(stamp, index)}
                 stamp={stamp}
                 context='collection' />
    );
  },

  renderZine(zine, index) {
    return (
      <ZineItem {...this.getItemProps(zine, index)}
                zine={zine}
                context='collection' />
    );
  },

  renderPinterestImage(image, index) {
    return (
      <PinterestImage {...this.getItemProps(image, index)}
                      image={image}
                      context='collection' />
    );
  },

  renderUser(user, index) {
    return (
      <UserItem {...this.getItemProps(user, index)}
                user={user} />
    );
  },

  renderActivities(activityOrGroup) {
    if (isArray(activityOrGroup)) {
      return activityOrGroup.map(this.renderActivity);
    } else {
      return this.renderActivity(activityOrGroup);
    }
  },

  renderActivity(activity) {
    return (
      <Activity key={activity.id}
                activity={activity}
                context='Collection' />
    );
  },

  renderMessage(message, index) {
    return (
      <Message {...this.getItemProps(message, index)}
                message={message}
                context='collection' />
    );
  }
});

module.exports = Collection;



/** WEBPACK FOOTER **
 ** ./organisms/Collection.jsx
 **/